import { render, staticRenderFns } from "./AvenantItemManager.vue?vue&type=template&id=1df21fdb&scoped=true"
import script from "./AvenantItemManager.vue?vue&type=script&lang=ts"
export * from "./AvenantItemManager.vue?vue&type=script&lang=ts"
import style0 from "./AvenantItemManager.vue?vue&type=style&index=0&id=1df21fdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df21fdb",
  null
  
)

export default component.exports